
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mypage/passes",
      function () {
        return require("private-next-pages/mypage/passes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mypage/passes"])
      });
    }
  